import { connect } from 'react-redux'
import { useTracking, track } from 'lib/analytics'
import { sentiments } from 'registry/constants'
import {
  MeltingSmileIcon,
  SmilingSunIcon,
  SunglassesFlowerIcon,
} from 'baby-ui/foundation/BabylistIcons/BabylistIcons'
import css from './sentiment.styles.scss'
import Slide from '../../Slide/Slide'
import { setUserResponse } from '../../../actions'
import {
  ButtonGroup,
  ButtonRect,
} from '../../OnboardingButtons/OnboardingButtons'
import { urlWithChecklistParam } from 'utils'
import { useNavigate } from 'react-router-dom-v5-compat'

interface SentimentProps {
  nextPath: string
  setUserResponse: (data: any) => void
}

type SentimentKeys = keyof typeof sentiments
type SentimentValues = (typeof sentiments)[SentimentKeys]

function Sentiment({ setUserResponse, nextPath }: SentimentProps) {
  const tracker = useTracking()
  const navigate = useNavigate()

  function handleOnClick(sentiment: SentimentValues) {
    tracker.trackEvent({
      event: track.onboardingQuestionAnswered,
      eventLocation: track.EventLocation.ONBOARDING_MINUS_SENTIMENT,
      answer: sentiment,
    })
    setUserResponse({ sentiment })
    navigate(urlWithChecklistParam(nextPath))
  }

  return (
    <div className={css.Sentiment__container}>
      <Slide title="How are you feeling about this whole registry thing?">
        <ButtonGroup>
          <ButtonRect
            className={css.Sentiment__button}
            onClick={() => handleOnClick(sentiments.EXCITED)}
          >
            <SmilingSunIcon />
            <div className="h3 mbn">So excited!</div>
          </ButtonRect>
          <ButtonRect
            className={css.Sentiment__button}
            onClick={() => handleOnClick(sentiments.OVERWHELMED)}
          >
            <MeltingSmileIcon />
            <div className="h3 mbn">Overwhelmed</div>
          </ButtonRect>
          <ButtonRect
            className={css.Sentiment__button}
            onClick={() => handleOnClick(sentiments.EXPLORING)}
          >
            <SunglassesFlowerIcon />
            <div className="h3 mbn">Just exploring</div>
          </ButtonRect>
        </ButtonGroup>
      </Slide>
    </div>
  )
}

export default connect(null, { setUserResponse })(Sentiment)
